import Image from 'snippets/image/image'

function Logo({ settings }) {
  return (
    <div class="flex justify-center truncate w-[99px] h-[40px]">
      <a href="/" class="flex justify-start items-center truncate text-center text-xl font-bold" title={settings?.shopName}>
        {settings.logo ? (
          <Image
            imageUrl={[settings.logo]}
            className="w-full h-auto"
            alt={settings?.shopName}
            width={settings?.width}
            height={settings?.height}
          />
        ) : (
          settings?.shopName
        )}
      </a>
    </div>
  )
}

export default Logo
